
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minor-policy",
      function () {
        return require("private-next-pages/minor-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minor-policy"])
      });
    }
  